import Input from "../../../../../input/Input";
import PropTypes from "prop-types";
import './DishOptionCreator.scss';
import RemoveAction from "../../../../../action/remove/RemoveAction";
import DishValueCreator from "./value/DishValueCreator";

const DishOptionCreator = ({id, optionIndex, option, onChange, onRemove}) => {
    const {title, values} = option;
    const key = `${id}-${optionIndex}`;
    const handleRemove = () => {
        onRemove(optionIndex);
    }

    const handleOptionChange = (value, name) => {
        onChange({...option, [name]: value}, optionIndex);
    }
    const handleChangeValues = (newValues) => {
        handleOptionChange(newValues, 'values');
    }
    const handleChangeValue = (newValue, name) => {
        const newValues = values.map(
            (value, index) => name === `${index}` ? newValue : value
        );
        handleChangeValues(newValues);
    };
    const isValueEmpty = (targetIndex) => values[targetIndex].length === 0;
    const handleAddValue = (targetIndex) => {
        if (isValueEmpty(targetIndex)) {
            return;
        }
        const newValues = [...values, ''];
        handleChangeValues(newValues);
    };
    const handleRemoveValue = (targetIndex) => {
        const isLastValue = values.length === 1;
        if (!isValueEmpty(targetIndex) || isLastValue) {
            return;
        }
        const newValues = values.filter((value, index) => targetIndex !== index);
        handleChangeValues(newValues);
    };
    return (
        <div className="dish-option-creator">
            <div className="dish-option-creator__header">
                <Input
                    id={`dish-option-title-${key}`}
                    autoFocus
                    value={title}
                    onChange={handleOptionChange}
                    placeholder="Option title"
                    name="title"
                />
                <RemoveAction onClick={handleRemove}/>
            </div>
            <div className="dish-option-creator__values">
                {values.map((value, valueIndex) => (
                    <DishValueCreator
                        key={`${key}-${valueIndex}`}
                        id={`dish-option-value-${key}-${valueIndex}`}
                        autoFocus={!!title}
                        index={valueIndex}
                        value={value}
                        onChange={handleChangeValue}
                        onEnter={handleAddValue}
                        onBackspace={handleRemoveValue}
                    />
                ))}
            </div>
        </div>
    );
};

DishOptionCreator.propTypes = {
    id: PropTypes.string.isRequired,
    optionIndex: PropTypes.number.isRequired,
    option: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
}

export default DishOptionCreator;